var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_871)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3_871)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3_871)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66061 5.25091C2.78934 5.52477 3.10796 6.0662 3.10796 6.0662L6.79142 0.00500488L3.19646 2.50381C2.98226 2.64605 2.80651 2.83859 2.68474 3.06443C2.52101 3.40515 2.43402 3.77735 2.42984 4.15501C2.42568 4.53267 2.50443 4.90668 2.66061 5.25091Z",
    fill: "#2C99E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.20118 7.24676C1.24177 7.82648 1.40634 8.39097 1.68386 8.90228C1.96139 9.41365 2.34547 9.86007 2.81038 10.2116L6.78672 12.9715C6.78672 12.9715 4.29888 9.40273 2.20049 5.85155C1.98805 5.47638 1.84524 5.06618 1.77889 4.6406C1.74951 4.44788 1.74951 4.25186 1.77889 4.05914C1.72417 4.16006 1.61796 4.36669 1.61796 4.36669C1.4052 4.79863 1.26029 5.26051 1.18831 5.73622C1.14688 6.23906 1.15118 6.74464 1.20118 7.24676Z",
    fill: "#2C99E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3456 7.72574C11.2169 7.45178 10.8983 6.9104 10.8983 6.9104L7.21484 12.9716L10.8097 10.4743C11.024 10.3321 11.1997 10.1396 11.3215 9.9137C11.4854 9.57286 11.5726 9.20038 11.5767 8.82237C11.5809 8.4444 11.5021 8.07009 11.3456 7.72574Z",
    fill: "#2C99E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.805 5.72983C12.7644 5.15006 12.5999 4.58559 12.3223 4.07425C12.0448 3.56291 11.6607 3.1165 11.1959 2.7649L7.21948 0.00500488C7.21948 0.00500488 9.70573 3.57381 11.8057 7.12499C12.0176 7.50027 12.1599 7.91053 12.2257 8.33592C12.2551 8.52869 12.2551 8.72465 12.2257 8.91737C12.2804 8.81652 12.3866 8.60989 12.3866 8.60989C12.5993 8.17789 12.7443 7.71598 12.8162 7.24032C12.8582 6.73753 12.8545 6.23195 12.805 5.72983Z",
    fill: "#2C99E0"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.68486 3.06443C2.80663 2.83859 2.98238 2.64605 3.19659 2.50381L6.79154 0.00500488L3.10808 6.06783C3.10808 6.06783 2.78624 5.5264 2.66072 5.25249C2.50431 4.90807 2.42542 4.53377 2.42959 4.15581C2.43376 3.77785 2.52089 3.40537 2.68486 3.06443ZM1.20118 7.24677C1.24177 7.82649 1.40634 8.39097 1.68386 8.90229C1.96139 9.41365 2.34547 9.86007 2.81038 10.2117L6.78672 12.9715C6.78672 12.9715 4.29888 9.40274 2.20049 5.85155C1.98805 5.47638 1.84524 5.06618 1.77889 4.64061C1.74951 4.44789 1.74951 4.25187 1.77889 4.05915C1.72417 4.16007 1.61796 4.3667 1.61796 4.3667C1.4052 4.79864 1.26029 5.26051 1.18831 5.73623C1.14688 6.23911 1.15118 6.74464 1.20118 7.24677ZM11.3391 7.72726C11.2104 7.45334 10.8918 6.91197 10.8918 6.91197L7.21475 12.9715L10.8097 10.4743C11.0239 10.3321 11.1997 10.1396 11.3214 9.9137C11.4854 9.5728 11.5725 9.20032 11.5767 8.82231C11.5808 8.44439 11.502 8.07008 11.3456 7.72568L11.3391 7.72726ZM12.7987 5.73145C12.758 5.15163 12.5935 4.58719 12.3159 4.07585C12.0385 3.56451 11.6544 3.1181 11.1895 2.7665L7.21958 0.00500488C7.21958 0.00500488 9.70578 3.57381 11.8057 7.12499C12.0176 7.50027 12.1599 7.91053 12.2258 8.33592C12.2551 8.52869 12.2551 8.72465 12.2258 8.91737C12.2805 8.81652 12.3867 8.60989 12.3867 8.60989C12.5994 8.17789 12.7444 7.71599 12.8163 7.24032C12.8583 6.73753 12.8546 6.23195 12.8051 5.72983L12.7987 5.73145Z",
    fill: "#4A73F7"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_871"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(0.5 0.00500488)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3_871"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(0.5 0.00500488)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3_871"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(0.5 0.00500488)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRite);
export default __webpack_public_path__ + "static/media/rite.37332fe001bb2bb0b15cadfffd491a55.svg";
export { ForwardRef as ReactComponent };